'use client';

import React from 'react';
import { HStack, Text } from '@ui-library';

import MoonSvg from '@/components/icons/Moon';
import GuestSvg from '@/components/icons/Guest';
import ChildSvg from '@/components/icons/Child';
import { getNightCount } from '@/components/check-in/components/utils';

type ReservationDetailBadgeProps = {
  quantity: number | string;
  icon: React.ReactElement;
  bgColor?: string;
};

export const ReservationDetailBadge = ({
  quantity,
  icon,
  bgColor = 'gray.100',
}: ReservationDetailBadgeProps) => (
  <HStack background={bgColor} p={1} borderRadius="md">
    <Text fontWeight="semibold" fontSize="sm" color="black">
      {quantity}
    </Text>
    {icon}
  </HStack>
);

type ReservationDetailsBadgesProps = {
  startDate: string;
  endDate: string;
  adultsCount: number | string;
  childrenCount: number | string;
  companyTimezone: string;
  bgColor?: string;
};

export const ReservationDetailsBadges = ({
  startDate,
  endDate,
  adultsCount,
  childrenCount,
  companyTimezone,
  bgColor = 'gray.100',
}: ReservationDetailsBadgesProps) => (
  <HStack gap={2}>
    <ReservationDetailBadge
      quantity={getNightCount(startDate, endDate, companyTimezone)}
      icon={<MoonSvg />}
      bgColor={bgColor}
    />
    <ReservationDetailBadge
      quantity={Number(adultsCount) || 0}
      icon={<GuestSvg />}
      bgColor={bgColor}
    />
    <ReservationDetailBadge
      quantity={Number(childrenCount) || 0}
      icon={<ChildSvg />}
      bgColor={bgColor}
    />
  </HStack>
);
